export function addDefinedValues<T>(existingValues: T, newValues: Partial<T>, excludeEmptyString: boolean = true): T {
  const result: T = { ...existingValues };

  for (const key in newValues) {
    if (Object.hasOwn(newValues, key)) {
      const value = newValues[key];
      if (value !== undefined) {
        if (!excludeEmptyString || value !== '') {
          result[key] = value;
        }
      }
    }
  }

  return result;
}
